export const SETTINGS_ENDPOINTS = {
  CHECK_UNIQUE: "/users/check-unique",
  UPDATE_PROFILE: "/users/update-profile",
};
